import React, { useContext } from 'react';

import CommonCardShell from '../../Layout/CommonCardShell/CommonCardShell';
import GroupInviteCTA from '../CtaCards/GroupInviteCTA/GroupInviteCTA';
import AdminMenuSection, {
    ButtonTypes,
} from '../Modals/AdminMenuSection/AdminMenuSection';
import GroupChatPreview from '../GroupChatPreview/GroupChatPreview';
import AboutCard from '../AboutCard/AboutCard';
import UserIconListDisplay from '../../Users/UserIconListDisplay/UserIconListDisplay';
import RulesCard from '../RulesCard/RulesCard';
import { GroupContext, PageContext } from '../../../contexts/ContextCreator';
import { groupActions } from '../../Includes/GroupActionTypes';
import './GroupsRightRail.scss';

const GroupsRightRail = () => {
    const groupContext = useContext(GroupContext);
    const { modalTrigger, pageProps } = useContext(PageContext);
    const groupInviteCtaProps = {
        modalTrigger,
        group: groupContext?.group,
        featureFlags: pageProps.featureFlags,
    };

    const messageType = 'group-chat-room';
    const channelKey = `${messageType}-${groupContext.group.hash}`;
    // @TODO CommonCardShell Abstraction
    return (
        <div className="component-Groups-GroupsRightRail">
            {groupContext?.hasPermission(groupActions.CAN_INVITE) && (
                <CommonCardShell>
                    <GroupInviteCTA {...groupInviteCtaProps} />
                </CommonCardShell>
            )}
            {groupContext.hasPermission(groupActions.SHOW_ADMIN_MENU) && (
                <CommonCardShell>
                    <AdminMenuSection
                        groupHash={groupContext?.group?.hash}
                        buttonType={ButtonTypes.NORMAL}
                    />
                </CommonCardShell>
            )}
            {groupContext.hasPermission(groupActions.GROUP_CHAT) && (
                <CommonCardShell>
                    <GroupChatPreview
                        messageType={messageType}
                        channelKey={channelKey}
                        buttonType={ButtonTypes.NORMAL}
                    />
                </CommonCardShell>
            )}
            <CommonCardShell>
                <AboutCard
                    displayText={groupContext?.group?.aboutGroup}
                    locationList={groupContext?.group?.locations}
                />
            </CommonCardShell>
            <UserIconListDisplay
                getUserList={groupContext.getMemberList}
                header="members"
                hint="A = Admin; M = Moderator"
                showVipBadge={false}
                displayOnCenterRail={false}
            />
            {groupContext?.group?.rules && (
                <CommonCardShell>
                    <RulesCard displayText={groupContext.group.rules} />
                </CommonCardShell>
            )}
        </div>
    );
};

GroupsRightRail.displayName = 'GroupsRightRail';

export default React.memo(GroupsRightRail);
